
















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import KeyValue from "@/models/keyValue.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import AcademicArea from "@/models/academic/academicArea.model";

@Component
export default class AcademicAreaTableComponent extends GenericBTable<
  AcademicArea
> {
  created() {
    this.permissionValue = PermissionValue.AREASACADEMICAS;
    this.tableConfig.controller = "AcademicArea";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let key = new BTableColumn("name", "table.name", true);
    this.tableConfig.insertColumns(key);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
}
